export type MarkdownBlockSegment = {
  kind: 'markdown' | 'code'
  content: string
}

export type CodeBlockParseResult = {
  isCodeBlock: boolean
  content: string
  segments: MarkdownBlockSegment[]
}

export function parseMarkdownCodeBlock(text: string): CodeBlockParseResult {
  const normalized = text.replace(/\r\n?/g, '\n')
  const segments: MarkdownBlockSegment[] = []
  const markdownLines: string[] = []
  const codeLines: string[] = []
  const flush = (kind: 'markdown' | 'code', lines: string[]) => {
    const content = lines.join('\n')
    if (!content) return
    segments.push({ kind, content })
    lines.length = 0
  }

  let inCode = false
  normalized.split('\n').forEach((line) => {
    const trimmed = line.trimStart()
    const isFence = trimmed.startsWith('```')
    if (isFence) {
      if (inCode) {
        flush('code', codeLines)
        inCode = false
      } else {
        flush('markdown', markdownLines)
        inCode = true
      }
      return
    }
    if (inCode) {
      codeLines.push(line)
    } else {
      markdownLines.push(line)
    }
  })

  flush(inCode ? 'code' : 'markdown', inCode ? codeLines : markdownLines)

  if (!segments.length) {
    return {
      isCodeBlock: false,
      content: normalized,
      segments: [{ kind: 'markdown', content: normalized }]
    }
  }

  const hasMeaningfulMarkdown = segments.some(segment => segment.kind === 'markdown' && segment.content.trim() !== '')
  const codeSegments = segments.filter(segment => segment.kind === 'code')
  const isCodeBlock = codeSegments.length === 1 && !hasMeaningfulMarkdown
  const content = isCodeBlock ? codeSegments[0].content : normalized

  return {
    isCodeBlock,
    content,
    segments
  }
}
